import { Identifier } from 'ra-core';

import { API_HANDLERS } from '@/api';
import { ICompanyCohortItemResponseParams } from '@/types';

export const getCohortsList = async (
  companyId: Identifier,
): Promise<ICompanyCohortItemResponseParams[]> => {
  try {
    const { data: responseData } = await API_HANDLERS.COMPANY.GET_COHORTS_LIST(companyId);

    return responseData;
  } catch (error) {
    return Promise.reject(new Error(`Get Company Cohorts List Error: ${error}`));
  }
};
